import {IdObjectsWithId} from "../../utils";
import {IFeed} from "../feed/types";

export interface Organization extends OrganizationEntitiesIds {
    id: string;
    name: string;
    status: string;
    logo: string;
}

export interface OrganizationEntitiesIds {
    campaign_ids: string[] | undefined | null;
    ad_label_ids: string[] | undefined | null;
    feed_ids: string[] | undefined | null;
}

export interface Campaign {
    id: string;
    status: string;
    name: string;
    conversion_event: string;
    target_url: string;
    code: string;
    organization_id: string;
    // lookups: null,
    ad_ids: Array<string>;
    audience_id: string;
    external_name: string;
}

export interface Ads {
    ad_type: string
    content_type: string;
    id: string;
    label_id: string;
    campaign_id: string;
    name: string;
    status: string;
    target_url: string | null;
    template_value: string;
}

export interface CampaignWithAds extends Campaign {
    ads: Ads[]
}

export interface AdLabel {
    activate_at: string;
    active_ad_count: number;
    ad_count: number;
    deletable: boolean;
    id: string;
    // last_used_at: null;
    name: string;
    // pause_at: null
    // updatable: true
}


export interface SampleUsers {
    id: string; // campaign id
    sample_user_ids: string[]; // list of the sample_user coming from forecasts
}

export interface Audience {
    id: string;
    content: Object
}

export interface Profile {
    id: string; // idfa or gaid
    audiences: IdObjectsWithId<Audience>
}

export interface OrganizationsState extends OrganizationEntity, CampaignEntity, OrganizationFilters {
    readonly organizations: IdObjectsWithId<Organization>
    readonly activeOrganizationId: string;
    readonly activeCampaignIds: string[];
    readonly activeAdsId: string;
}

export interface OrganizationEntity {
    readonly campaigns: IdObjectsWithId<Campaign>;
    readonly adLabels: IdObjectsWithId<AdLabel>;
    readonly feeds: IdObjectsWithId<IFeed>;
    readonly profiles: IdObjectsWithId<Profile>
}

export interface CampaignEntity {
    readonly ads: IdObjectsWithId<Ads>;
    readonly sampleUsers: IdObjectsWithId<SampleUsers>;
}

export interface OrganizationFilters {
    readonly organizationsFilter: OrganizationsFilter
    readonly campaignsFilter: CampaignsFilter
    readonly adsFilter: AdsFilter
}

export enum OrganizationsFilter {
    SHOW_ALL,
    SHOW_ACTIVE,
}

export enum CampaignsFilter {
    SHOW_ALL,
    SHOW_ACTIVE,
}

export enum AdsFilter {
    SHOW_ALL,
    SHOW_ACTIVE,
}
